exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p label {\n  display: inline-block;\n  width: 100%;\n}\np input, p select {\n  display: inline-block;\n  width: 100%;\n}\np .button {\n  width: 100%;\n}\n.title {\n  display: block;\n}\n.title:first-letter {\n  text-transform: uppercase;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/request-form/request-form.component.scss
// module id = ../../../../../src/app/components/request-form/request-form.component.scss
// module chunks = main